import React, {CSSProperties, FunctionComponent, useState} from 'react';
import ReactMde from 'react-mde';
import 'react-mde/lib/styles/css/react-mde-all.css';
import * as Showdown from 'showdown';
import { InputLabelEditor } from '../../../components/InputLabelEditor';
import {Separator} from './Separator';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import classNames from 'classnames';
import { ChangelogVersion } from '@lfp-digital/back-types-mpg';
import Dropzone from 'react-dropzone';
import { postImageUpload } from '../../../components/NotificationEditor/components/AvatarSelect';
import { useDispatch } from 'react-redux';

const converter = new Showdown.Converter({
  tables: true,
  simplifiedAutoLink: true,
  strikethrough: true,
  tasklists: true,
});

const Styles: Record<string, CSSProperties> = {
  container: {
    position: 'relative',
    overflow: 'auto',
    height: 'calc(100vh - 200px)',
  },
  inputContainer: {
    marginBottom: 16,
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
  },
  dropZone: {
    width: 360,
    minHeight: 200,
    border: '1px dashed #4054CC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#4054CC',
    cursor: 'pointer',
  },
};

export type VersionEditorProps = {
  onChange: (key: string, value: any) => void;
  data: Partial<ChangelogVersion>;
  isCreation?: boolean;
  errorForSubmit?: boolean;
};

export const VersionEditor: FunctionComponent<VersionEditorProps> = ({data, onChange, isCreation, errorForSubmit}) => {
  const dispatch = useDispatch();
  
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>(
    'write',
  );

  const isPublished = data?.status === 'published';


  return (
    <div style={Styles.container}>
      <Separator />
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="VERSION" isRequired />
        <input
          placeholder='x.x.x'
          disabled={!isCreation}
          className="form-control"
          value={data?.version || ''}
          onChange={(e) => onChange('version', e.target.value)}
        />
        {errorForSubmit ? <div style={{ fontSize: 12, color: "red", marginTop: 1 }}>Please match the requested format (x.x.x)</div> : null}
      </div>
      <Separator />
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="NAME" isRequired />
        <input
          className="form-control"
          value={data?.name || ''}
          onChange={e => onChange('name', e.target.value)}
        />
      </div>
      <Separator />
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="IMAGE" />
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <Dropzone
            style={Styles.dropZone}
            onDrop={acceptedFiles => {
              const onSuccess = (imageUrl: string) => {
                onChange('imageUrl', imageUrl);
              };
              dispatch(postImageUpload(acceptedFiles[0], onSuccess));
            }}>
            <div>
              {!data?.imageUrl ? (
                <span>Parcourir ou Drag n Drop</span>
              ) : (
                <img
                  src={data.imageUrl}
                  style={{maxWidth: 360}}
                  alt=""
                />
              )}
            </div>
          </Dropzone>
          {data?.imageUrl && (
            <div
              onClick={() =>
                onChange('imageUrl', undefined)
              }
              style={{
                marginLeft: 16,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 30,
                height: 30,
                backgroundColor: 'red',
                borderRadius: 30,
                cursor: 'pointer',
              }}>
              <i style={{color: 'white'}} className="fa fa-trash" />
            </div>
          )}
        </div>
      </div>
      <Separator />
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="DESCRIPTION" />
        <ReactMde
          toolbarCommands={[
            ['bold', 'italic', 'strikethrough'],
            ['unordered-list', 'ordered-list'],
            ['link'],
          ]}
          value={data?.description || ''}
          onChange={value =>
            onChange('description', value)
          }
          selectedTab={selectedTab}
          onTabChange={setSelectedTab}
          generateMarkdownPreview={markdown =>
            Promise.resolve(converter.makeHtml(markdown))
          }
        />
      </div>
      <Separator />
      <div style={Styles.inputContainer}>
        <InputLabelEditor title="DATE" isRequired />
        <div id="NotificationEditor">
          <DatePicker
            selected={
              data?.versionDate ? new Date(data.versionDate) : null
            }
            onChange={date => {
              onChange('versionDate', moment(date).utc().format('YYYY-MM-DD'));
            }}
            dateFormat="d/M/yyyy"
            placeholderText="Select a date"
          />
        </div>
      </div>
      {!isCreation ? (
        <>
          <Separator />
          <div style={Styles.inputContainer}>
            <InputLabelEditor title="STATUS" isRequired />
            <div style={Styles.toggleContainer}>
              <div style={Styles.toggleLabelContainer}>
                Is published?
              </div>
              <div>
                <i
                  style={{color: isPublished ? '#4054CC' : 'black'}}
                  onClick={() => {
                    onChange('status', data?.status === 'published' ? 'draft' : 'published');
                  }}
                  className={classNames('fa fa-2x', {
                    'fa-toggle-on': isPublished,
                    'fa-toggle-off': !isPublished,
                  })}
                />
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Versions/Editor/index.tsx